import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import FlagIcon from './FlagIcon';

const { FiGlobe, FiChevronDown } = FiIcons;

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'sv', name: 'Svenska' },
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' },
    { code: 'fr', name: 'Français' }
  ];

  const currentLanguage = languages.find(lang => lang.code === language);

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 rounded-lg hover:bg-white/10 transition-colors duration-200"
      >
        <SafeIcon icon={FiGlobe} className="w-5 h-5 text-white" />
        <span className="text-white font-medium hidden sm:flex items-center space-x-2">
          <FlagIcon country={currentLanguage?.code} className="w-6 h-4 inline-block" />
          <span>{currentLanguage?.name}</span>
        </span>
        <SafeIcon icon={FiChevronDown} className={`w-4 h-4 text-white transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            {/* Backdrop */}
            <div
              className="fixed inset-0 z-40"
              onClick={() => setIsOpen(false)}
            />
            
            {/* Dropdown */}
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
              className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg overflow-hidden z-50"
            >
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => handleLanguageChange(lang.code)}
                  className={`w-full flex items-center space-x-3 px-4 py-3 hover:bg-gray-100 transition-colors duration-200 ${
                    language === lang.code ? 'bg-accent-green/10' : ''
                  }`}
                >
                  <FlagIcon country={lang.code} className="w-7 h-5 flex-shrink-0" />
                  <span className={`font-medium ${language === lang.code ? 'text-accent-green' : 'text-gray-700'}`}>
                    {lang.name}
                  </span>
                  {language === lang.code && (
                    <span className="ml-auto text-accent-green">✓</span>
                  )}
                </button>
              ))}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};

export default LanguageSwitcher;